import { PRODUCTS_BUSINESS_ENDPOINT } from 'common/constants/endpoints'
import { request } from 'common/utils/requests'

import { SaveProductMutation, SaveProductMutationVariables, ProductInput } from '../interfaces/schemaDefinition'

import query from './saveProduct.graphql'

export const saveProduct = async (product: ProductInput): Promise<SaveProductMutation> =>
  request<SaveProductMutation, SaveProductMutationVariables>(PRODUCTS_BUSINESS_ENDPOINT, query, { product })
